import React from "react";
import { formatDate } from "../../../Utils/utils";

const SpecialNotes = ({ SpecialNoteData }) => {
  if (!SpecialNoteData) return <div>Loading...</div>;

  // Extract notes data from SpecialNoteData
  const notesList = SpecialNoteData?.data || [];
  

  return (
    <div>
      {notesList.length > 0 ? (
        notesList.map((note, index) => (
          <div key={note.id} className="card p-4 mb-4" style={{ backgroundColor: "#E6E6E6" }}>
            <div className="d-flex flex-column gap-2">
              <span>{formatDate(note.createdAt)}</span>
              <span className="ms-3">
                <i className="f-14 fw-400">{index + 1}</i>
                {"."}
                <i className="f-14 fw-400">{note.notes}</i>
              </span>
            </div>
          </div>
        ))
      ) : (
        <div>No Special Notes Found!</div>
      )}
    </div>
  );
};

export default SpecialNotes;
